module.exports = __webpack_public_path__ + "media/images/emblems/Sutz-Lattrigen-coat_of_arms-5d24684b73eb6748202938d946973f88.svg";